import React, { FC } from 'react'

const BgArrow: FC<{className: string}> = ({className}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="62" height="16" 
      viewBox="0 0 62 16" 
      fill="none"
      className={className}
    >
      <path 
        d="M61.7071 8.70711C62.0976 8.31658 62.0976 7.68342 61.7071 7.29289L55.3432 0.928932C54.9526 0.538408 54.3195 0.538408 53.9289 
        0.928932C53.5384 1.31946 53.5384 1.95262 53.9289 2.34315L59.5858 8L53.9289 13.6569C53.5384 14.0474 53.5384 14.6805 53.9289 15.0711C54.3195 
        15.4616 54.9526 15.4616 55.3432 15.0711L61.7071 8.70711ZM1 9H61V7H1V9Z" 
        fill="#E8DDD8"
      />
      <path 
        d="M0.292889 8.70711C-0.0976334 8.31658 -0.0976334 7.68342 0.292889 7.29289L6.65685 0.928932C7.04737 0.538408 7.68054 0.538408 8.07106 
        0.928932C8.46159 1.31946 8.46159 1.95262 8.07106 2.34315L2.41421 8L8.07106 13.6569C8.46159 14.0474 8.46159 14.6805 8.07106 15.0711C7.68054 
        15.4616 7.04737 15.4616 6.65685 15.0711L0.292889 8.70711ZM61 9H0.999996V7H61V9Z" 
        fill="#E8DDD8"
      />
    </svg>
  )
}

export default BgArrow